import { defineComponent } from 'vue';
import useTransactionsStore from '@/store/modules/transactions';
import { storeToRefs } from 'pinia';
export default defineComponent({
    name: 'RateTimer',
    emits: ['selected'],
    setup() {
        const transactionsStore = useTransactionsStore();
        const { selectedCrypto, selectedCurrency, usdRate, currentRate } = storeToRefs(transactionsStore);
        const getLocalCryptoRate = () => usdRate.value * currentRate.value;
        return {
            selectedCrypto,
            selectedCurrency,
            getLocalCryptoRate,
        };
    },
});
